import React from 'react';

export const ReportBookingDate = (value: any) => <React.Fragment>{value}</React.Fragment>;
